import itAuth from './auth'
import itCompany from './company'
import itError from './error'
import itMeasure from './measure'
import itMenu from './menu'
import itMisc from './misc'
import itOptional from './optional'
import itPantone from './pantone'
import itPrice from './price'
import itProduct from './product'
import itQuote from './quote'
import itRegistry from './registry'
import itReport from './report'
import itSuperAdmin from './superAdmin'
import itUser from './user'
const itMessages = {
    ...itError,
    ...itAuth,
    ...itMisc,
    ...itMenu,
    ...itMeasure,
    ...itOptional,
    ...itUser,
    ...itCompany,
    ...itRegistry,
    ...itProduct,
    ...itPantone,
    ...itSuperAdmin,
    ...itQuote,
    ...itPrice,
    ...itReport
}

export default itMessages